/**
 * Atlas PM · 系统设置 · 任务模板管理 · 接口封装（P8.2）
 *
 * 对接后端 TaskTemplateController（apps/api/src/modules/template/task-template.controller.ts）：
 *   GET    /task-templates        列表（可见范围：超管=全部；普通=自己的个人 + 全部公共）
 *   PATCH  /task-templates/:id    编辑基本信息（名称/说明/范围/启用状态）
 *   DELETE /task-templates/:id    删除（个人仅创建人；公共仅超管/template:manage）
 *
 * ⚠️ 实际路径由 api/client 补 `/api` 前缀 → `/api/task-templates`。
 */

import { api, qs } from '../../../api/client';
import type { Paginated } from '../../../api/types';

/** 模板可见性：个人 / 公共 */
export type TemplateScope = 'PERSONAL' | 'PUBLIC';

export interface TaskTemplateItem {
  id: string;
  name: string;
  description: string | null;
  scope: TemplateScope;
  categoryId: string | null;
  categoryName: string | null;
  metricCount: number;
  elementCount: number;
  createdByName: string | null;
  /** 创建人 id（据此判断是否本人创建） */
  createdById: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/** 列表查询参数 */
export interface TaskTemplateListParams {
  scope?: TemplateScope;
  keyword?: string;
  /** 显式按启用状态过滤（true=仅启用 / false=仅停用） */
  isActive?: boolean;
  /** 为 true 时不加启用过滤，返回「含停用」的全部（「全部状态」筛选用） */
  includeInactive?: boolean;
  page?: number;
  pageSize?: number;
}

/** 编辑入参：只改基本信息，全部可选 */
export interface TaskTemplateUpdateInput {
  name?: string;
  description?: string;
  scope?: TemplateScope;
  isActive?: boolean;
}

const BASE = '/task-templates';

export const taskTemplateAdminApi = {
  list: (params: TaskTemplateListParams = {}) =>
    api.get<Paginated<TaskTemplateItem>>(`${BASE}${qs({ ...params })}`),
  update: (id: string, input: TaskTemplateUpdateInput) =>
    api.patch<TaskTemplateItem>(`${BASE}/${id}`, input),
  remove: (id: string) => api.delete<{ ok: true; id: string }>(`${BASE}/${id}`),
};
